import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import SvgIcon from '../../SvgIcon';
import styles from './MultiSelectFacet.module.less';

const MultiSelectFacet = ({
  displayName,
  internalName,
  href,
  disabled = false,
  selected = false,
  onClick,
}) => {
  let abreviatedName =
    displayName === 'Kindergarten' ? 'K' : displayName.replace(' grade', '');

  const handleClick = e => {
    if (!disabled && typeof onClick === 'function') {
      onClick(e, href);
    }
  };

  const content = (
    <>
      {selected && (
        <SvgIcon name="close" className={styles.icon} aria-label="Remove" />
      )}
      <p>{abreviatedName}</p>
    </>
  );

  const classes = clsx(styles.link, selected && styles.selected);

  let facetLink;
  if (selected) {
    facetLink = (
      <button
        className={classes}
        onClick={handleClick}
        role="button"
        title={`Remove filter ${displayName}`}
        tabIndex={0}
      >
        {content}
      </button>
    );
  } else {
    facetLink = (
      <a
        className={classes}
        href={disabled ? undefined : href}
        onClick={handleClick}
      >
        {content}
      </a>
    );
  }

  return (
    <li
      key={internalName}
      className={clsx(styles.facet, disabled && styles.hidden)}
    >
      {facetLink}
    </li>
  );
};

MultiSelectFacet.displayName = 'MultiSelectFacet';
MultiSelectFacet.propTypes = {
  displayName: PropTypes.string,
  internalName: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  nestedTags: PropTypes.array,
  href: PropTypes.string,
  onClick: PropTypes.func,
  count: PropTypes.number,
  hasChildren: PropTypes.bool,
  group: PropTypes.string,
};

export default MultiSelectFacet;
